import { render, staticRenderFns } from "./ReviewCriteriaInUseError.vue?vue&type=template&id=32b8aca4&"
import script from "./ReviewCriteriaInUseError.vue?vue&type=script&lang=js&"
export * from "./ReviewCriteriaInUseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
